'use client';

import type { Photo } from '@/lib/types';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { X } from 'lucide-react';

interface PhotoViewerProps {
  photo: Photo;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export function PhotoViewer({ photo, isOpen, onOpenChange }: PhotoViewerProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className="p-0 bg-transparent border-0 max-w-full w-screen h-screen flex items-center justify-center outline-none"
        onClick={() => onOpenChange(false)}
        showCloseButton={false}
      >
        <VisuallyHidden>
          <DialogTitle>Photo Viewer</DialogTitle>
        </VisuallyHidden>

        <DialogClose className="absolute right-4 top-4 text-white opacity-70 transition-opacity hover:opacity-100 z-50">
          <X className="h-8 w-8" />
        </DialogClose>

        <div
          className="relative flex items-center justify-center"
          onClick={(e) => e.stopPropagation()} // Clicks here won't close
        >
          <img
            src={photo.imageUrl}
            alt="Event photo"
            className="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain shadow-2xl"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
